import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@/components/shadcn/button";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

export type ActionConfig = {
  icon: IconDefinition,
  title: string,
  onClick: () => void
};

type ActionCellProps = {
  actions: ActionConfig[]
};

export const ActionCell = ({ actions }: ActionCellProps) => {
  return (
    <>
      {actions.map((action) => (
        <Button
          variant="icon"
          size="sm"
          title={action.title}
          onClick={action.onClick}
        >
          <FontAwesomeIcon icon={action.icon} className="!h-3.5 !w-3.5" />
        </Button>
      ))}
    </>
  );
};
